import { render } from "./BodyPortal.vue?vue&type=template&id=187bdf20"
import script from "./BodyPortal.vue?vue&type=script&lang=js"
export * from "./BodyPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__